module.exports = __webpack_public_path__ + "89781f1da78dbc5586d72f9c76f06e09.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/myles-borins.jpg
 ** module id = 423
 ** module chunks = 0
 **/